import { DithertronSettings } from "../common/types";
import * as palettes from "./palettes";

export const SYSTEMS: (DithertronSettings | null)[] = [
    {
        id: 'c64.multi',
        name: 'C-64 Multi',
        width: 160,
        height: 200,
        scaleX: 0.936 * 2,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w:4, h:8, colors: 4, xb:1, yb:2 },
        cell: {w: 4, h: 8, msbToLsb: true },
        paletteChoices:{background: true},        
        cb: { w: 4, h: 8, xb: 1, yb: 2 },
        param: { extra: 1 },
        toNative: 'exportC64Multi',
    },
    {
        id: 'c64.multi.fli',
        name: 'C-64 Multi FLI (w/o bug)',
        width: 160,
        height: 200,
        scaleX: 0.936 * 2,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 4, h: 1, colors: 4, xb: 1 },
        paletteChoices:{ background: true },
        cell: {w: 4, h: 8, msbToLsb: true },
        cb: { w: 4, h: 8, xb: 1, yb: 2 },
        param: { extra: 1 },
        fli: { bug: false, blankLeft: false, blankRight: false, blankColumns: 3 },
        toNative: 'exportC64Multi',
    },
    {
        id: 'c64.multi.fli.bug',
        name: 'C-64 Multi FLI (with bug)',
        width: 160,
        height: 200,
        scaleX: 0.936 * 2,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 4, h: 1, colors: 4, xb: 1 },
        cell: {w: 4, h: 8, msbToLsb: true },
        paletteChoices: { background: true },
        cb: { w: 4, h: 8, xb: 1, yb: 2 },
        param: { extra: 1 },
        fli: { bug: true, blankLeft: false, blankRight: false, blankColumns: 3 },
        toNative: 'exportC64Multi',
    },
    {
        id: 'c64.multi.fli.blank.left',
        name: 'C-64 Multi FLI (Left blank)',
        width: 160,
        height: 200,
        scaleX: 0.936 * 2,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 4, h: 1, colors: 4, xb: 1 },
        cell: {w: 4, h: 8, msbToLsb: true },
        paletteChoices: { background: true },
        cb: { w: 4, h: 8, xb: 1, yb: 2 },
        param: { extra: 1 },
        fli: { bug: false, blankLeft: true, blankRight: false, blankColumns: 3 },
        toNative: 'exportC64Multi',
    },
    {
        id: 'c64.multi.fli.blank',
        name: 'C-64 Multi FLI (L/R blank)',
        width: 160,
        height: 200,
        scaleX: 0.936 * 2,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 4, h: 1, colors: 4, xb: 1 },
        cell: {w: 4, h: 8, msbToLsb: true },
        paletteChoices: { background:true },
        cb: { w: 4, h: 8, xb: 1, yb: 2 },
        param: { extra: 1 },
        fli: { bug: false, blankLeft: true, blankRight: true, blankColumns: 3 },
        toNative: 'exportC64Multi',
    },
    {
        id: 'c64.hires',
        name: 'C-64 Hires',
        width: 320,
        height: 200,
        scaleX: 0.936,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: {w: 8, h: 8, msbToLsb: true },
        param: { extra: 1 },
        toNative: 'exportC64Hires',
    },
    {
        id: 'c64.hires.fli',
        name: 'C-64 Hires FLI (w/o bug)',
        width: 320,
        height: 200,
        scaleX: 0.936,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 8, h: 1, colors: 2 },
        cell: {w: 8, h: 8, msbToLsb: true },
        param: { extra: 1 },
        fli: { bug: false, blankLeft: false, blankRight: false, blankColumns: 3 },
        toNative: 'exportC64Hires',
    },
    {
        id: 'c64.hires.fli.bug',
        name: 'C-64 Hires FLI (with bug)',
        width: 320,
        height: 200,
        scaleX: 0.936,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 8, h: 1, colors: 2 },
        cell: {w: 8, h: 8, msbToLsb: true },
        param: { extra: 1 },
        fli: { bug: true, blankLeft: false, blankRight: false, blankColumns: 3 },
        toNative: 'exportC64Hires',
    },
    {
        id: 'c64.hires.fli.blank',
        name: 'C-64 Hires FLI (L/R blank)',
        width: 320,
        height: 200,
        scaleX: 0.936,
        conv: 'VICII_Canvas',
        pal: palettes.VIC_PAL_RGB,
        block: { w: 8, h: 1, colors: 2 },
        cell: {w: 8, h: 8, msbToLsb: true },
        param: { extra: 1 },
        fli: { bug: false, blankLeft: true, blankRight: true, blankColumns: 3 },
        toNative: 'exportC64Hires',
    },
    {
        id: 'nes',
        name: 'NES (4 color, 240 tiles)',
        width: 160,
        height: 96,
        scaleX: 8 / 7,
        conv: 'DitheringCanvas',
        pal: palettes.NES_RGB,
        reduce: 4,
        toNative: 'exportNES',
    },
    {
        id: 'msx',
        name: 'MSX/Coleco (TMS9918A)',
        width: 256,
        height: 192,
        conv: 'Msx_Canvas',
        pal: palettes.TMS9918_RGB,
        block: { w: 8, h: 1, colors: 2 },
        cell: {w: 8, h: 8, msbToLsb: true },
        toNative: 'exportTMS9918',
    },
    {
        id: 'apple2.hires',
        name: 'Apple ][ (Hires)',
        width: 140,
        height: 192,
        scaleX: 2,
        conv: 'Apple2_Canvas',
        pal: palettes.AP2HIRES_RGB,
        block: { w: 7, h: 1, colors: 4 },
        toNative: 'exportApple2HiresToHGR',
    },
    {
        id: 'atari8.d',
        name: 'Atari ANTIC (Mode D)',
        width: 160,
        height: 96,
        scaleX: 0.8571,
        conv: 'DitheringCanvas',
        pal: palettes.VCS_RGB,
        reduce: 4,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 2, brev: true },
    },
    {
        id: 'atari8.f.10',
        name: 'Atari ANTIC (Mode F/10)',
        width: 80,
        height: 192,
        scaleX: 0.8571 * 4,
        conv: 'DitheringCanvas',
        pal: palettes.VCS_RGB,
        reduce: 9,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 4, brev: true },
    },
    {
        id: 'vcs',
        name: 'Atari VCS',
        width: 40,
        height: 192,
        scaleX: 6,
        conv: 'DitheringCanvas',
        pal: palettes.VCS_RGB,
        reduce: 2,
        toNative: 'exportVCSPlayfield',
    },
    {
        id: 'vcs.color',
        name: 'Atari VCS (Color)',
        width: 40,
        height: 192,
        scaleX: 6,
        conv: 'VCSColorPlayfield_Canvas',
        pal: palettes.VCS_RGB,
        toNative: 'exportVCSPlayfield',
    },
    {
        id: 'astrocade',
        name: 'Bally Astrocade',
        width: 160,
        height: 98,
        scaleX: 1,
        conv: 'DitheringCanvas',
        pal: palettes.ASTROCADE_RGB,
        reduce: 4,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 2, brev: true },
    },
    {
        id: 'zx',
        name: 'ZX Spectrum',
        width: 256,
        height: 192,
        conv: 'ZXSpectrum_Canvas',
        pal: palettes.ZXSPECTRUM_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        toNative: 'exportZXSpectrum'
    },
    {
        id: 'zx.dark',
        name: 'ZX Spectrum (dark only)',
        width: 256,
        height: 192,
        conv: 'ZXSpectrum_Canvas',
        pal: palettes.ZXSPECTRUM_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: { colorsRange: { min: 0, max: 7 } },
        toNative: 'exportZXSpectrum'
    },
    {
        id: 'zx.bright',
        name: 'ZX Spectrum (bright only)',
        width: 256,
        height: 192,
        conv: 'ZXSpectrum_Canvas',
        pal: palettes.ZXSPECTRUM_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: { colorsRange: { min: 8, max: 15 } },
        toNative: 'exportZXSpectrum'
    },
    {
        id: 'zx.dark.bright',
        name: 'ZX Spectrum (dark made bright only)',
        width: 256,
        height: 192,
        conv: 'ZXSpectrum_Canvas',
        pal: palettes.ZXSPECTRUM_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: { colorsRange: { min: 0, max: 7 } }, // aux is used to signal the special mode
        customize: { flipPalette: true },
        toNative: 'exportZXSpectrum'
    },
    {
        id: 'zx.bright.dark',
        name: 'ZX Spectrum (bright made dark only)',
        width: 256,
        height: 192,
        conv: 'ZXSpectrum_Canvas',
        pal: palettes.ZXSPECTRUM_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: { colorsRange: { min: 8, max: 15 } }, // aux is used to signal the special mode
        customize: { flipPalette: true },
        toNative: 'exportZXSpectrum'
    },
    {
        id: 'cpc.mode0',
        name: 'Amstrad CPC (mode 0)',
        width: 160,
        height: 200,
        scaleX: 2,
        conv: 'DitheringCanvas',
        pal: palettes.AMSTRAD_CPC_RGB,
        reduce: 16,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 4, yremap: [3, 80, 2048], bitremap: [7, 3, 5, 1, 6, 2, 4, 0] }
    },
    {
        id: 'cpc.mode1',
        name: 'Amstrad CPC (mode 1)',
        width: 320,
        height: 200,
        scaleX: 1,
        conv: 'DitheringCanvas',
        pal: palettes.AMSTRAD_CPC_RGB,
        reduce: 4,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 2, yremap: [3, 80, 2048], bitremap: [7, 3, 6, 2, 5, 1, 4, 0] }
    },

    // null == separator, systems with runnable source code are above
    null,

    {
        id: 'vic20.hires',
        name: 'VIC-20 Hires',
        width: 160,
        height: 160,
        scaleX: 1.5,
        conv: 'VICII_Canvas',
        pal: palettes.VIC20_PAL_RGB,
        block: { w: 8, h: 8, colors: 2 },               // can choose the background, or one foreground color
        cell: {w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            background: true,                           // pixels can choose the background color
            backgroundRange: { min: 0, max: 7 },        // (but with a reduced color palette)
            colorsRange: { min: 0, max: 7 }             // pixels can only choose from a reduced color palette
        },
        toNative:'exportVicHires',
    },
    {
        id: 'vic20.multi',
        name: 'VIC-20 Multi',
        width: 80,
        height: 160,
        scaleX: 3,
        conv: 'VICII_Canvas',
        pal: palettes.VIC20_PAL_RGB,
        block: { w: 4, h: 8, colors: 4 },               // can choose background, aux, border and one foreground color
        cell: {w: 4, h: 8, msbToLsb: true },    
        paletteChoices: {
            background: true,                           // pixels can choose the background color
            backgroundRange: { min: 0, max: 15 },
            aux: true,                                  // pixels can choose the aux color
            auxRange: { min: 0, max: 15},
            border: true,                               // pixels can choose the border color
            borderRange: { min: 0, max: 7 },            // (but with a reduced palette)
            colorsRange: { min: 0, max: 7 }             // a reduced palette applies to the pixel colors
        },
        toNative:'exportVicMulti',
    },
    {
        id: 'nes.1bpp',
        name: 'NES (1bpp) (8x8) (32x32) Planar',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 2, msbToLsb: false },  // bit plane colors are stored LSB to MSB
        cell: { w: 8, h: 8, msbToLsb: true },                // cell pixels are stored MSB to LSB
        paletteChoices: {
            backgroundRange: { min: 0, max: 1 },
            auxRange: { min: 0, max: 1 },
            borderRange: { min: 0, max: 1 },
            colorsRange: { min: 0, max: 1 }
        },
        reduce: 2,
        customize: { outputTileset: false, outputPalette: true },
        toNative:'exportSNES'
    },
    {
        id: 'nes.2bpp',
        name: 'NES (2bpp) (8x8) (32x32) Planar',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 4, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 3 },
            auxRange: { min: 0, max: 3 },
            borderRange: { min: 0, max: 3 },
            colorsRange: { min: 0, max: 3 }
        },
        reduce: 4,
        customize: { outputTileset: false, outputPalette: true },
        toNative:'exportSNES'
    },
    {
        id: 'snes.2bpp',
        name: 'SNES (+Gameboy/GBC) (2bpp) (8x8) (32x32) Planar',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 4, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 3 },
            auxRange: { min: 0, max: 3 },
            borderRange: { min: 0, max: 3 },
            colorsRange: { min: 0, max: 3 }
        },
        customize: { outputTileset: false, outputPalette: false, planeToMemory: 'interleaved' },
        reduce: 4,
        toNative:'exportSNES'
    },
    {
        id: 'snes.3bpp',
        name: 'SNES (3bpp) (8x8) (32x32) Planar',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 8, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 7 },
            auxRange: { min: 0, max: 7 },
            borderRange: { min: 0, max: 7 },
            colorsRange: { min: 0, max: 7 }
        },
        reduce: 8,
        customize: { planeToMemory: 'interleaved' },
        toNative:'exportSNES'
    },
    {
        id: 'snes.4bpp',
        name: 'SNES (4bpp) (8x8) (32x32) Planar',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 16, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 15 },
            auxRange: { min: 0, max: 15},
            borderRange: { min: 0, max: 15 },
            colorsRange: { min: 0, max: 15 }
        },
        customize: { planeToMemory: 'interleaved' },
        reduce: 16,
        toNative:'exportSNES'
    },
    {
        id: 'snes.8bpp',
        name: 'SNES (8bpp) (8x8) (32x32) Planar',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 256, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 255 },
            auxRange: { min: 0, max: 255 },
            borderRange: { min: 0, max: 255 },
            colorsRange: { min: 0, max: 255 }
        },
        customize: { planeToMemory: 'interleaved' },
        reduce: 256,
        toNative:'exportSNES'
    },
    {
        id: 'snes.mode7',
        name: 'SNES (Mode 7) (8bpp) (8x8) (32x32)',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 256, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 255 },
            auxRange: { min: 0, max: 255 },
            borderRange: { min: 0, max: 255 },
            colorsRange: { min: 0, max: 255 }
        },
        customize: { bitsInPlane: 8, planes: 1 },
        reduce: 256,
        toNative:'exportSNES'
    },
    {
        id: 'neo.geopocket',
        name: 'NEO Geo Pocket Color (2pp) (8x8) (32x32)',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 256, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 255 },
            auxRange: { min: 0, max: 255 },
            borderRange: { min: 0, max: 255 },
            colorsRange: { min: 0, max: 255 }
        },
        customize: { outputTileset: false, outputPalette: false, bitsInPlane: 2, planes: 1, planeLittleEndian: false },
        reduce: 256,
        toNative:'exportSNES'
    },
    {
        id: 'virtualboy',
        name: 'Virtual Boy (2pp) (8x8) (32x32)',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 4, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 3 },
            auxRange: { min: 0, max: 3 },
            borderRange: { min: 0, max: 3 },
            colorsRange: { min: 0, max: 3 }
        },
        customize: { outputTileset: false, outputPalette: false, bitsInPlane: 2, planes: 1, planeLittleEndian: true },
        reduce: 4,
        toNative:'exportSNES'
    },
    {
        id: 'gg.4pp',
        name: 'Game Gear (+Sega Master Systems/Wonder Color) (4bpp) (8x8) (32x32) Linear',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 16, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 15 },
            auxRange: { min: 0, max: 15 },
            borderRange: { min: 0, max: 15 },
            colorsRange: { min: 0, max: 15 }
        },
        customize: { outputTileset: false, outputPalette: false, planeToMemory: 'linear' },
        reduce: 16,
        toNative:'exportSNES'
    },
    {
        id: 'genesis',
        name: 'Genesis/x68k (4pp) (8x8) (32x32)',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas',
        pal: palettes.SNES_B5G5R5_RGB,
        block: { w: 8, h: 8, colors: 16, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 15 },
            auxRange: { min: 0, max: 15 },
            borderRange: { min: 0, max: 15 },
            colorsRange: { min: 0, max: 15 }
        },
        customize: { outputTileset: false, outputPalette: false, bitsInPlane: 4, planes: 1, planeLittleEndian: true },
        reduce: 16,
        toNative:'exportSNES'
    },
    {
        id: 'snes.8bpp.direct',
        name: 'SNES (8bpp) (8x8) (32x32) Direct Color',
        width: 32*8,
        height: 32*8,
        scaleX: 1,
        conv: 'SNES_Canvas_Direct',
        pal: palettes.SNES_BBPGGGPRRRP,
        block: { w: 8, h: 8, colors: 2048, msbToLsb: false },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: {
            backgroundRange: { min: 0, max: 2047 },
            auxRange: { min: 0, max: 2047 },
            borderRange: { min: 0, max: 2047 },
            colorsRange: { min: 0, max: 2047 }
        },
        customize: { outputTileset: true, outputPalette: false, transformColor: 'bbgggrrr', planes: 8 },
        toNative:'exportSNES'
    },
    {
        id: 'stic',
        name: 'Intellivision STIC (GRAM/GROM) (FGBG)',
        width: 8*8,    // actual is 20x12 but the gram only allows for 64 gram cards
        height: 8*8,
        conv: 'Stic_Fgbg_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        paletteChoices: { backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 7 } },
        toNative: 'exportSticFgbg'
    },
    {
        id: 'stic.stack.grom',
        name: 'Intellivision STIC (GROM only) (Color Stack Mode)',
        width: 20*8,
        height: 12*8,
        conv: 'Stic_ColorStack_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        cb: { w: 8, h: 8, xb: 0, yb: 0 },   // important to leave xb/yb as 0 (so no color bleeding happens in scoring of stack colors)
        param: { extra: 4 },
        paletteChoices: { colors: 1, backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 7 } },
        toNative: 'exportSticColorStack'
    },
    {
        id: 'stic.stack.gram',
        name: 'Intellivision STIC (GRAM only) (Color Stack Mode)',
        width: 8*8,    // actual is 20x12 but the gram only allows for 64 gram cards
        height: 8*8,
        conv: 'Stic_ColorStack_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        cb: { w: 8, h: 8 },
        param: { extra: 4 },
        paletteChoices: { colors: 1, backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 15 } },
        toNative: 'exportSticColorStack'
    },
    {
        id: 'stic.stack.gromram',
        name: 'Intellivision STIC (GROM+GRAM) (Color Stack Mode)',
        width: 20*8,
        height: 12*8,
        conv: 'Stic_ColorStack_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true, xb: 0, yb: 0 }, // important that xb/yb are 0 (so no color bleeding happens in scoring)
        cb: { w: 8, h: 8 },
        // the cell params will carry the array of which cells will use the gram (instead of the grom)
        param: { cell: true, extra: 4 },
        paletteChoices: { colors: 1, backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 7 } },
        toNative: 'exportSticColorStack'
    },
    {
        id: 'stic.stack.grom.single',
        name: 'Intellivision STIC (GROM only) (Single BG Color Stack)',
        width: 20*8,
        height: 12*8,
        conv: 'Stic_ColorStack_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        cb: { w: 8, h: 8, xb: 0, yb: 0 },   // important to leave xb/yb as 0 (so no color bleeding happens in scoring of stack colors)
        param: { extra: 4 },
        paletteChoices: { colors: 1, backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 7 } },
        customize: { singleColor: true },
        toNative: 'exportSticColorStack'
    },
    {
        id: 'stic.stack.gram.single',
        name: 'Intellivision STIC (GRAM only) (Single BG Color Stack)',
        width: 8*8,    // actual is 20x12 but the gram only allows for 64 gram cards
        height: 8*8,
        conv: 'Stic_ColorStack_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true },
        cb: { w: 8, h: 8 },
        param: { extra: 4 },
        paletteChoices: { colors: 1, backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 15 } },
        customize: { singleColor: true },
        toNative: 'exportSticColorStack'
    },    
    {
        id: 'stic.stack.gromram.single',
        name: 'Intellivision STIC (GROM+GRAM) (Single BG Color Stack)',
        width: 20*8,
        height: 12*8,
        conv: 'Stic_ColorStack_Canvas',
        pal: palettes.INTELLIVISION_STIC_RGB,
        block: { w: 8, h: 8, colors: 2 },
        cell: { w: 8, h: 8, msbToLsb: true, xb: 0, yb: 0 }, // important that xb/yb are 0 (so no color bleeding happens in scoring)
        cb: { w: 8, h: 8 },
        // the cell params will carry the array of which cells will use the gram (instead of the grom)
        param: { cell: true, extra: 4 },
        paletteChoices: { colors: 1, backgroundRange: { min: 0, max: 15 }, colorsRange: { min: 0, max: 7 } },
        customize: { singleColor: true },
        toNative: 'exportSticColorStack'
    },
    {
        id: 'nes4f',
        name: 'NES (4 color, full screen)',
        width: 256,
        height: 240,
        scaleX: 8 / 7,
        conv: 'DitheringCanvas',
        pal: palettes.NES_RGB,
        reduce: 4,
        toNative: 'exportNES',
    },
    {
        id: 'nes5f',
        name: 'NES (5 color, full screen)',
        width: 256,
        height: 240,
        scaleX: 8 / 7,
        conv: 'NES_Canvas',
        pal: palettes.NES_RGB,
        reduce: 5,
        toNative: 'exportNES',
    },
    {
        id: 'atari7800.160a',
        name: 'Atari 7800 (160A)',
        width: 160,
        height: 240,
        scaleX: 2,
        conv: 'DitheringCanvas',
        pal: palettes.VCS_RGB,
        reduce: 4,
    },
    {
        id: 'atari7800.160b',
        name: 'Atari 7800 (160B)',
        width: 160,
        height: 240,
        scaleX: 2,
        conv: 'DitheringCanvas',
        pal: palettes.VCS_RGB,
        reduce: 12,
    },
    {
        id: 'sms',
        name: 'Sega Master System',
        width: 176, // only 488 unique tiles max, otherwise 256x240
        height: 144,
        scaleX: 8 / 7,
        conv: 'DitheringCanvas',
        pal: palettes.SMS_RGB,
        reduce: 16,
    },
    {
        id: 'sms-gg',
        name: 'Sega GameGear',
        width: 160,
        height: 144,
        scaleX: 1.2,
        conv: 'DitheringCanvas',
        pal: palettes.GAMEGEAR_COLOR_RGB,
        reduce: 16,
    },
    {
        id: 'bbcmicro.mode2',
        name: 'BBC Micro (mode 2)',
        width: 160,
        height: 256,
        scaleX: 2,
        conv: 'DitheringCanvas',
        pal: palettes.TELETEXT_RGB,
    },
    {
        id: 'apple2.lores',
        name: 'Apple ][ (Lores)',
        width: 40,
        height: 48,
        scaleX: 1.5,
        conv: 'DitheringCanvas',
        pal: palettes.AP2LORES_RGB,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 4 },
    },
    {
        id: 'apple2.dblhires',
        name: 'Apple ][ (Double-Hires)',
        width: 140,
        height: 192,
        scaleX: 2,
        conv: 'DitheringCanvas',
        pal: palettes.AP2LORES_RGB,
    },
    {
        id: 'appleiigs.320.16',
        name: 'Apple IIGS (16 colors)',
        width: 320,
        height: 200,
        conv: 'DitheringCanvas',
        pal: palettes.IIGS_COLOR_RGB,
        reduce: 16,
    },
    {
        id: 'channelf',
        name: 'Fairchild Channel F',
        width: 102,
        height: 58,
        conv: 'DitheringCanvas',
        pal: palettes.CHANNELF_RGB,
        reduce: 4, // TODO: https://geeks-world.github.io/articles/467811/index.html
    },
    {
        id: 'mac',
        name: 'Mac 128K',
        width: 512,
        height: 342,
        conv: 'DitheringCanvas',
        pal: palettes.MONO_RGB,
    },
    {
        id: 'x86.cga.04h.1',
        name: 'PC CGA (Mode 04h, palette 1)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB_1,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 2 },
    },
    {
        id: 'x86.cga.04h.1B',
        name: 'PC CGA (Mode 04h, bright 1)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB_1H,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 2 },
    },
    {
        id: 'x86.cga.04h.2',
        name: 'PC CGA (Mode 04h, palette 2)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB_2,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 2 },
    },
    {
        id: 'x86.cga.04h.2B',
        name: 'PC CGA (Mode 04h, bright 2)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB_2H,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 2 },
    },
    {
        id: 'x86.cga.05h',
        name: 'PC CGA (Mode 05h)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB_3,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 2 },
    },
    {
        id: 'x86.cga.05h.B',
        name: 'PC CGA (Mode 05h, bright)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB_3H,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 2 },
    },
    {
        id: 'x86.ega.0dh',
        name: 'PC EGA (Mode 0Dh)',
        width: 320,
        height: 200,
        scaleX: 200 / 320 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 4 },
    },
    {
        id: 'x86.ega.10h',
        name: 'PC EGA (Mode 10h)',
        width: 640,
        height: 350,
        scaleX: 350 / 640 * 1.37,
        conv: 'DitheringCanvas',
        pal: palettes.CGA_RGB,
        toNative: 'exportFrameBuffer',
        exportFormat: { bpp: 1, np: 4 },
    },
    {
        id: 'williams',
        name: 'Williams Arcade',
        width: 304,
        height: 256,
        conv: 'DitheringCanvas',
        pal: palettes.WILLIAMS_RGB,
        reduce: 16,
    },
    {
        id: 'pico8',
        name: 'PICO-8',
        width: 128,
        height: 128,
        conv: 'DitheringCanvas',
        pal: palettes.PICO8_RGB,
    },
    {
        id: 'tic80',
        name: 'TIC-80',
        width: 240,
        height: 136,
        conv: 'DitheringCanvas',
        pal: palettes.TIC80_RGB,
    },
    {
        id: 'gb',
        name: 'Game Boy Classic',
        width: 160,
        height: 144,
        scaleX: 10 / 9,
        conv: 'DitheringCanvas',
        pal: palettes.GAMEBOY_GREEN_RGB,
    },
    /*
    {
        id:'gbc',
        name:'Game Boy Color',
        width:160,
        height:144,
        aspect:1,
        conv:'DitheringCanvas',
        pal:GAMEBOY_COLOR_RGB,
        reduce:32,
    },
    */
    {
        id: 'amiga.lores',
        name: 'Amiga (Lores)',
        width: 320,
        height: 256,
        conv: 'DitheringCanvas',
        pal: palettes.AMIGA_OCS_COLOR_RGB,
        reduce: 32,
        //toNative:'exportFrameBuffer',
        //exportFormat:{bpp:1,brev:true,np:5},
    },
    {
        id: 'amiga.lores.ham6',
        name: 'Amiga (Lores, HAM6)',
        width: 320,
        height: 256,
        conv: 'HAM6_Canvas',
        pal: palettes.AMIGA_OCS_COLOR_RGB,
        reduce: 16,
        extraColors: 48,
        //toNative:'exportFrameBuffer',
        //exportFormat:{bpp:1,brev:true,np:6},
    },
    {
        id: 'cx16.lores',
        name: 'Commander X16 (Lores)',
        width: 320,
        height: 240,
        scaleX: 1,
        conv: 'DitheringCanvas',
        pal: palettes.AMIGA_OCS_COLOR_RGB,
        reduce: 256
    },
    {
        id: 'cx16.hires',
        name: 'Commander X16 (Hires, cropped)',
        width: 640,
        height: 400,
        scaleX: 1,
        conv: 'DitheringCanvas',
        pal: palettes.AMIGA_OCS_COLOR_RGB,
        reduce: 16
    },
    {
        id: 'compucolor',
        name: 'Compucolor',
        width: 160,
        height: 192,
        scaleX: 1.6,
        conv: 'Compucolor_Canvas',
        pal: palettes.ZXSPECTRUM_RGB,
        block: { w: 2, h: 4, colors: 2 },
    },
    // https://www.bighole.nl//pub/mirror/homepage.ntlworld.com/kryten_droid/teletext/spec/teletext_spec_1974.htm
    {
        id: 'teletext',
        name: 'Teletext',
        width: 40 * 2,
        height: 24 * 3,
        scaleX: 4 / 3,
        conv: 'Teletext_Canvas',
        pal: palettes.TELETEXT_RGB,
        block: { w: 2, h: 3, colors: 2 },
    },
    {
        id: 'atarist',
        name: 'Atari ST',
        width: 320,
        height: 200,
        scaleX: 1,
        conv: 'DitheringCanvas',
        pal: palettes.ATARIST_RGB,
        reduce: 16
    },
    {
        id: 'MC6847.CG2.palette0',
        name: 'MC6847 (CG2, palette 0)',
        width: 128,
        height: 64,
        scaleX: 1 / 1.3,
        conv: 'DitheringCanvas',
        pal: palettes.MC6847_PALETTE0,
        reduce: 4,
        toNative: 'exportMC6847'
    },
    {
        id: 'MC6847.CG2.palette1',
        name: 'MC6847 (CG2, palette 1)',
        width: 128,
        height: 64,
        scaleX: 1 / 1.3,
        conv: 'DitheringCanvas',
        pal: palettes.MC6847_PALETTE1,
        reduce: 4,
        toNative: 'exportMC6847'
    },
    {
        id: 'MC6847.CG3.palette0',
        name: 'MC6847 (CG3, palette 0)',
        width: 128,
        height: 96,
        scaleX: 1 / 1.3 * 96 / 64,
        conv: 'DitheringCanvas',
        pal: palettes.MC6847_PALETTE0,
        reduce: 4,
        toNative: 'exportMC6847'
    },
    {
        id: 'MC6847.CG3.palette1',
        name: 'MC6847 (CG3, palette 1)',
        width: 128,
        height: 96,
        scaleX: 1 / 1.3 * 96 / 64,
        conv: 'DitheringCanvas',
        pal: palettes.MC6847_PALETTE1,
        reduce: 4,
        toNative: 'exportMC6847'
    },
    {
        id: 'MC6847.CG6.palette0',
        name: 'MC6847 (CG6, palette 0)',
        width: 128,
        height: 192,
        scaleX: 1 / 1.3 * 192 / 64,
        conv: 'DitheringCanvas',
        pal: palettes.MC6847_PALETTE0,
        reduce: 4,
        toNative: 'exportMC6847'
    },
    {
        id: 'MC6847.CG6.palette1',
        name: 'MC6847 (CG6, palette 1)',
        width: 128,
        height: 192,
        scaleX: 1 / 1.3 * 192 / 64,
        conv: 'DitheringCanvas',
        pal: palettes.MC6847_PALETTE1,
        reduce: 4,
        toNative: 'exportMC6847'
    },
    {
        id: 'vcs.48',
        name: 'Atari VCS (48x48 bitmap)',
        width: 48,
        height: 48,
        conv: 'DitheringCanvas',
        pal: palettes.VCS_RGB,
        reduce: 2,
    },
    {
        id: 'pce.256x240',
        name: 'PC Engine (256x240)',
        width: 256,
        height: 240,
        scaleX: 5 / 4,
        conv: 'DitheringCanvas',
        pal: palettes.ATARIST_RGB,
        reduce: 16,
    },
];

export var SYSTEM_LOOKUP: { [id: string]: DithertronSettings } = {};
SYSTEMS.forEach((sys) => { if (sys) SYSTEM_LOOKUP[sys.id || sys.name] = sys; });

